// キャラクターの基本設定
//
// basePosition は内部解像度 1920×1024 基準（足元 = 接地点 を表す）
// 並び順は仕様書 4-1 に従い [凛久][ぽんた][ふわり][誠司]
// マスターはカウンター奥（4人より後ろ）なので配列の先頭に置く（＝一番奥に描画）
//
// parts の各要素:
//   { name, file, offsetX, offsetY, z, bob?, rotate?, sprite? }
//   - offsetX/Y はソース画像左上のアンカーからのオフセット（源画像pixel単位）
//   - z は描画順（小→奥）
//   - bob: true で頭部の上下バウンド
//   - rotate: { pivotX, pivotY, maxDeg, speed } で振り子アニメ

const CHARACTERS = [
  {
    // 前向き・前かがみのマスター（パーツ構成 確定版）
    id: 'master_walk',
    displayName: 'マスター(walk)',
    role: 'master', // 喫茶店のマスター（会話には参加しない）
    placeholderColor: '#8a7a6a',
    assetDir: '/img/characters/master',

    // カウンター奥を左→右へ歩く。bgPosition は縦位置の基準（横は move が上書き）
    bgPosition: { x: 420, y: 1208 },
    scale: 0.27, // 全高 1344px 基準。二回り小さめ
    behindSofa: true,
    // 歩行シーケンス（ループなし）。「もっと聴く」で頭から再生される
    //   1. いまいる位置 → 画面右外へ（初回は画面左外から）。カウンター奥 = zIndex 1
    //   2. 画面外で1秒待機
    //   3. 画面下部を右端の外 → 中央へ（desk と desk2 の間 = zIndex 9）
    //   4. 中央で3秒 master_back（後ろ姿）に交代 … 共有フラグ atTable
    //   5. 中央 → 左端の外へ歩いてはける
    //   6. 画面外で3秒待機
    //   7. カウンター奥を左端の外 → 画面中央へ（1と同じ高さ・レイヤー）
    //   8. master_nomal（正面・待機）に交代 … 共有フラグ idle
    move: {
      bobAmp: 22,
      bobSpeed: 420,
      loop: false,
      steps: [
        // fromX:'current' = いまマスターがいる位置から。初回は fallbackX（画面左外）
        { fromX: 'current', fallbackX: -350, toX: 2270, y: 1208, zIndex: 1, scaleMul: 1, flipX: false, speed: 100 },
        { hold: 1000 },
        // 右→左なので flipX で左右反転。zIndex 9 = desk(8) より手前・desk2(10) より奥
        { fromX: 2270, toX: 960, y: 1950, zIndex: 9, scaleMul: 1.8, flipX: true, speed: 82 },
        // 中央に着いたら3秒だけ非表示（この間 master_back が立っている）
        { hold: 3000, hide: true, set: { atTable: true } },
        // 再び登場して、そのまま左へ歩いて画面外へはける
        { fromX: 960, toX: -400, y: 1950, zIndex: 9, scaleMul: 1.8, flipX: true, speed: 85, set: { atTable: false } },
        // 画面外で3秒待機
        { hold: 3000, hide: true },
        // カウンター奥を、今度は画面左外 → 中央へ（右を向いて歩く）
        { fromX: -350, toX: 960, y: 1208, zIndex: 1, scaleMul: 1, flipX: false, speed: 100 },
        // 中央に着いたら非表示（ここから master_nomal に切り替わる）
        { hold: 999999, hide: true, set: { idle: true } },
      ],
    },
    // 寸法: body 909×975 / face 727×762 / ashi 477×520 / ude_r_1 196×337 / ude_r_2 241×409
    // ude_r_1 = 上腕（袖）、ude_r_2 = 前腕＋手。目/口のスプライトは無し。
    // サンプル準拠の配置（前かがみ気味に頭が body の右上へ深く重なる）
    parts: [
      // 足（body の後ろ）
      { name: 'ashi', file: 'ashi.png', offsetX: -317, offsetY: -520, z: 1 },
      // 体
      { name: 'body', file: 'body.png', offsetX: -641, offsetY: -1218, z: 3 },
      // 右腕（上腕 → 前腕＋手）。body の前
      // 上腕は肩を支点に小さめの振り子。前腕と同じ speed なので動きが連動する
      {
        name: 'ude_r_1',
        file: 'ude_r_1.png',
        offsetX: -304,
        offsetY: -1050,
        z: 4,
        // 歩幅に合わせて speed 420（bobSpeed の2倍周期＝2歩で1往復）
        rotate: { pivotX: -180, pivotY: -1030, maxDeg: 12, speed: 420 },
      },
      // 前腕は肘を支点に振り子アニメ。親を ude_r_1 にして肩の回転を引き継ぐ
      {
        name: 'ude_r_2',
        file: 'ude_r_2.png',
        parent: 'ude_r_1',
        offsetX: -306,
        offsetY: -773,
        z: 4.1,
        rotate: { pivotX: -257, pivotY: -758, maxDeg: 26, speed: 420 },
      },
      // 頭部（bob で揺れる）。最前面。bob の数値 = 振幅（ソース画像px、既定8）
      { name: 'face', file: 'face.png', offsetX: -85, offsetY: -1344, z: 7, bob: 60 },
    ],
  },
  {
    // 後ろ向きのマスター（back フォルダ。直立・左右対称・腕パーツ無し）
    id: 'master_back',
    displayName: 'マスター(back)',
    role: 'master',
    placeholderColor: '#8a7a6a',
    assetDir: '/img/characters/master/back',

    // master_walk が中央で止まっている間（共有フラグ atTable）だけ表示する
    // ＝ テーブルまで来たマスターが後ろを向く、という見え方
    bgPosition: { x: 960, y: 2010 },
    scale: 0.50, // master_walk の停止時（0.27 × 1.8）と頭の大きさが揃う値
    behindSofa: false,
    zIndex: 9, // desk(8) より手前・desk2(10) より奥
    move: { showWhen: 'atTable' },
    // 寸法: body 901×973 / face 708×762 / ashi 637×520
    parts: [
      // 足（body の後ろ）
      { name: 'ashi', file: 'ashi.png', offsetX: -319, offsetY: -520, z: 1 },
      // 体（上下に揺れる。bob の数値 = 振幅／ソース画像px）
      { name: 'body', file: 'body.png', offsetX: -450, offsetY: -1420, z: 3, bob: 25 },
      // 後頭部。最背面。上下 bob ではなく首を支点に左右へ振り子
      {
        name: 'face',
        file: 'face.png',
        offsetX: -354,
        offsetY: -1660, // 頭の下端が body 上端から約54%の深さ（肩に埋まる感じ）
        z: 0,
        rotate: { pivotX: 0, pivotY: -900, maxDeg: 8, speed: 900 },
      },
    ],
  },
  {
    // 通常時（カウンターで待機）のマスター = master_nomal
    // 素材は front フォルダ（正面向き・両腕あり・直立）
    id: 'master_nomal',
    displayName: 'マスター(通常)',
    role: 'master',
    placeholderColor: '#8a7a6a',
    assetDir: '/img/characters/master/front',

    // 歩行シーケンスの最後（80秒後）に、master_walk が止まった画面中央へ出現する
    // ＝ カウンター奥まで戻ってきて正面を向く、という見え方
    // （単体で置く場合の定位置は bgPosition { x: 420, y: 1248 } / scale 0.30）
    bgPosition: { x: 960, y: 1208 },
    scale: 0.28, // カウンター奥を歩く master_walk（scale 0.27）と頭の大きさが揃う値
    behindSofa: true,
    // 待機中は背景の一部として扱うので、発話ズーム時は背景と一緒にぼかす
    blurOnZoom: true,
    // カウンター奥をランダムに左右移動 → 止まって仕草 → 逆方向へ、を繰り返す
    move: {
      bobAmp: 14, // 移動中だけ軽く弾む
      bobSpeed: 420,
      wander: {
        startWhen: 'idle', // master_walk が中央に着くまで非表示
        startX: 960, // master_walk が止まる位置から引き継ぐ
        minX: 380, // 画面から切れない範囲
        maxX: 1560,
        minStep: 200, // 1回の移動距離（この範囲でランダム）
        maxStep: 780,
        speed: 90, // px/秒（背景座標）
        minPause: 4000, // 止まって仕草をしている時間
        maxPause: 9000,
      },
    },
    // 寸法: body 901×971 / face 708×762 / asi 637×520
    //       ude_l_1 196×337 / ude_l_2 234×408（画面左の腕：上腕→前腕＋手）
    //       ude_r_1 165×347 / ude_r_2 200×418（画面右の腕：上腕→前腕＋手）
    // 参考画像から各パーツの相対位置を実測して配置（左右対称）
    parts: [
      // 両腕。最前面（face より手前）
      // 腕はデフォルト静止。ランダムな間隔で「上げて下ろす」動きが入る。
      // 左右は group: 'arms' で排他 → 同時には動かず、どちらが動くかは毎回ランダム。
      // 前腕は syncWith で肩と同じタイミング（腕1本がまとまって動く）。
      {
        name: 'ude_l_1',
        file: 'ude_l_1.png',
        offsetX: -514,
        offsetY: -1141,
        z: 8,
        bob: 20,
        // 肩は大きめに回す（maxDeg の符号は左右で逆＝外側に開く向き）
        rotate: {
          pivotX: -399,
          pivotY: -1111,
          maxDeg: 80, // 外側＝横に大きく上げる
          speed: 900,
          // group: 'arms' で右腕と排他（左右が同時に動かない）
          // ease: 上げは素早く、下ろしはイージングアウトでゆっくり収める
          random: { minDelay: 2000, maxDelay: 6000, cycles: 1.6, group: 'arms', ease: true, riseRatio: 0.25 },
        },
      },
      // 前腕は肘（袖の上端）を支点。親は上腕（肩の回転を引き継ぐ）
      {
        name: 'ude_l_2',
        file: 'ude_l_2.png',
        parent: 'ude_l_1',
        offsetX: -669,
        offsetY: -850,
        z: 8.1,
        bob: 20,
        rotate: {
          pivotX: -489,
          pivotY: -815,
          maxDeg: 56,
          speed: 1000,
          // 肩に同期しつつ delay 分だけ遅れて動く（肩→肘のタメ）
          random: { syncWith: 'ude_l_1', cycles: 1.6, delay: 260, ease: true, riseRatio: 0.25 },
        },
      },
      {
        name: 'ude_r_1',
        file: 'ude_r_1.png',
        offsetX: 309,
        offsetY: -1141,
        z: 8,
        bob: 20,
        rotate: {
          pivotX: 369,
          pivotY: -1111,
          maxDeg: -80, // 外側＝横に大きく上げる
          speed: 820,
          random: { minDelay: 2000, maxDelay: 6000, cycles: 1.6, group: 'arms', ease: true, riseRatio: 0.25 },
        },
      },
      {
        name: 'ude_r_2',
        file: 'ude_r_2.png',
        parent: 'ude_r_1',
        offsetX: 390,
        offsetY: -850,
        z: 8.1,
        bob: 20,
        rotate: {
          pivotX: 445,
          pivotY: -820,
          maxDeg: -56,
          speed: 920,
          random: { syncWith: 'ude_r_1', cycles: 1.6, delay: 260, ease: true, riseRatio: 0.25 },
        },
      },
      // 足（body の後ろ）
      { name: 'asi', file: 'asi.png', offsetX: -321, offsetY: -520, z: 2 },
      // 体（上下に揺れる。bob の数値 = 振幅／ソース画像px）
      // 顔・両腕にも同じ bob を入れて上半身ごと動かす（足は接地したまま）
      { name: 'body', file: 'body.png', offsetX: -470, offsetY: -1271, z: 3, bob: 20 },
      // 顔。最前面（顎が body の上端から約45%の深さで重なる。両腕より手前）
      // デフォルトは静止。ランダムな間隔で首を左右に振る
      {
        name: 'face',
        file: 'face.png',
        offsetX: -374,
        offsetY: -1593,
        z: 9, // 最前面（両腕 8 / 8.1 より手前）
        bob: 20,
        rotate: {
          pivotX: -20,
          pivotY: -760,
          maxDeg: 9,
          speed: 900,
          random: { minDelay: 4000, maxDelay: 11000, cycles: 4 },
        },
      },
    ],
  },
  {
    id: 'riku',
    displayName: '瀬戸 凛久',
    role: 'tsukkomi', // ツッコミ
    basePosition: { x: 280, y: 1060 },
    scale: 0.39,
    placeholderColor: '#5a8fd6',
    assetDir: '/img/characters/riku',
    // 寸法: body 618×938 / face 994×818 / hair 1191×543 / ude_l 406×608 / ude_r 417×618 / asi 294×269
    // 初期オフセットはざっくり値。debug モードを ON にして調整してください。
    parts: [
      // 一番奥
      { name: 'ude_r', file: 'ude_r.png', offsetX: 180, offsetY: -1050, z: 1 },
      { name: 'asi_r', file: 'asi_r.png', offsetX: 150, offsetY: -450, z: 2 },
      { name: 'asi_l', file: 'asi_l.png', offsetX: 16, offsetY: -369, z: 2 },
      // 体
      { name: 'body', file: 'body.png', offsetX: -309, offsetY: -1207, z: 3 },
      // body の前
      {
        name: 'ude_l',
        file: 'ude_l.png',
        offsetX: -280,
        offsetY: -1040,
        z: 4,
        rotate: { pivotX: -210, pivotY: -1040, maxDeg: 12, speed: 1100 },
      },
      // 頭部（bob で揺れる）
      { name: 'face', file: 'face.png', offsetX: -497, offsetY: -1820, z: 5, bob: true },
      // 目（スプライトシートアニメーション。face の上、hair の下）
      { name: 'eye', sprite: 'eye.json', offsetX: -120, offsetY: -1550, z: 5.5, bob: true },
      // 口（スプライトシートアニメーション）
      { name: 'mouth', sprite: 'mouth.json', offsetX: -50, offsetY: -1350, z: 5.6, bob: true },
      { name: 'hair', file: 'hair.png', offsetX: -595, offsetY: -1900, z: 6, bob: true },
    ],
  },
  {
    id: 'ponta',
    displayName: '丑田 ぽんた',
    role: 'boke', // ボケ
    basePosition: { x: 760, y: 680 },
    scale: 0.39,
    placeholderColor: '#e8a04a',
    assetDir: '/img/characters/ponta',
    // 寸法: body 402×698 / face 825×717 / ude_l 158×698 / ude_r 158×698
    // 足回り・髪・腕アニメ無し
    parts: [
      
      // 体
      { name: 'body', file: 'body.png', offsetX: -201, offsetY: -740, z: 3 },
      // 右腕（画面左側、body の前）
      { name: 'ude_r', file: 'ude_r.png', offsetX: -280, offsetY: -590, z: 6 },
      // 左腕（画面右側、body の前。回転なし）
      
      { name: 'ude_l', file: 'ude_l.png', offsetX: 100, offsetY: -590, z: 4 },
      // 顔（bob で揺れる。ponta は髪パーツ無しで face だけ）
      { name: 'face', file: 'face.png', offsetX: -412, offsetY: -1300, z: 5, bob: true },
      // 目（スプライトシートアニメーション）
      { name: 'eye', sprite: 'eye.json', offsetX: -250, offsetY: -1120, z: 5.5, bob: true },
      // 口（スプライトシートアニメーション）
      { name: 'mouth', sprite: 'mouth.json', offsetX: -240, offsetY: -830, z: 5.6, bob: true },
    ],
  },
  {
    id: 'fuwari',
    displayName: '暁 ふわり',
    role: 'tennen', // 天然
    basePosition: { x: 1160, y: 640 },
    scale: 0.39,
    placeholderColor: '#d68fc6',
    assetDir: '/img/characters/fuwari',
    // 寸法: body 582×770 / face 650×931 / glass 658×236 / hair 482×570
    //        kata_l/r 133×353 / ude_l/r 158×422
    // kata（肩）+ ude（前腕）の2分割。腕アニメ無し。
    parts: [
      // 一番奥: 右肩 + 右前腕（body の後ろ）
      { name: 'kata_l', file: 'kata_l.png', offsetX: -340, offsetY: -600, z: 4 },
      { name: 'ude_l', file: 'ude_l.png', offsetX: -360, offsetY: -300, z: 4 },
      // 体
      { name: 'body', file: 'body.png', offsetX: -291, offsetY: -770, z: 3 },
      // body の前: 左肩 + 左前腕
      { name: 'kata_r', file: 'kata_r.png', offsetX: 200, offsetY: -600, z: 4 },
      { name: 'ude_r', file: 'ude_r.png', offsetX: 200, offsetY: -300, z: 4 },
      // 頭部（bob で揺れる）
      { name: 'face', file: 'face.png', offsetX: -325, offsetY: -1540, z: 5, bob: true },
      // 目（スプライトシートアニメーション）
      { name: 'eye', sprite: 'eye.json', offsetX: -180, offsetY: -1200, z: 7, bob: true },
      // 口（スプライトシートアニメーション）
      { name: 'mouth', sprite: 'mouth.json', offsetX: -90, offsetY: -1100, z: 7.5, bob: true },
      { name: 'glass', file: 'glass.png', offsetX: -329, offsetY: -1400, z: 8, bob: true },
      { name: 'hair', file: 'hair.png', offsetX: -241, offsetY: -1750, z: 6, bob: true },
    ],
  },
  {
    id: 'seiji',
    displayName: '九条 誠司',
    role: 'majime', // 真面目
    basePosition: { x: 1600, y: 1000 },
    scale: 0.39,
    placeholderColor: '#5ac49a',
    assetDir: '/img/characters/seiji',
    // 寸法: body 497×904 / face 754×772 / hair 905×730 / ude_l 399×622 / ude_r 400×622 / asi 190×253
    parts: [
      // 一番奥
      { name: 'ude_r', file: 'ude_r.png', offsetX: -520, offsetY: -1050, z: 1 },
      { name: 'asi_r', file: 'asi_r.png', offsetX: -400, offsetY: -420, z: 2 },
      { name: 'asi_l', file: 'asi_l.png', offsetX: -300, offsetY: -369, z: 2 },
      // 体
      { name: 'body', file: 'body.png', offsetX: -248, offsetY: -1207, z: 3 },
      // body の前
      { name: 'ude_l', file: 'ude_l.png', offsetX: -130, offsetY: -1040, z: 4 },
      // 頭部（bob で揺れる）
      { name: 'face', file: 'face.png', offsetX: -377, offsetY: -1820, z: 5, bob: true },
      // 目（スプライトシートアニメーション）
      { name: 'eye', sprite: 'eye.json', offsetX: -200, offsetY: -1500, z: 7, bob: true },
      // 口（スプライトシートアニメーション）
      { name: 'mouth', sprite: 'mouth.json', offsetX: -100, offsetY: -1380, z: 7.5, bob: true },
      { name: 'hair', file: 'hair.png', offsetX: -452, offsetY: -1950, z: 6, bob: true },
    ],
  },
];

export default CHARACTERS;
